<template>
  <div>
    <el-row class="headler" style="height: 100px">
      <el-col :span="6" class="headlerlogotitle flex_center">
        <!--        <el-image style="width: 66px" :src="require('@@/assets/logo.png')"></el-image>-->
        <span style="font-size: 20px;">四川顺智招投标代理有限公司</span>
      </el-col>
      <el-col :span="12" style="padding-top: 18px">
        <el-menu mode="horizontal" :default-active="current" class="headmenu flex_content"
                 active-text-color="#F18C1D" text-color="#333333" @select="handleSelect">
          <template v-for="item in menuItems">
            <el-menu-item v-if="!item.children || !item.children.length" :key="item.location"
                          :index="item.location" style="height: 60px;">
              <a :href="item.location" @click.prevent style="font-size: 20px;">{{ item.label }}</a>
            </el-menu-item>
            <el-submenu v-else :key="item.location" :index="item.location">
              <template slot="title"><span style="font-size: 20px">{{ item.label }}</span></template>
              <el-menu-item v-for="child in item.children" :key="child.location" style="height: 60px;">
                <a :href="child.location" @click.prevent>{{ child.label }}</a>
              </el-menu-item>
            </el-submenu>
          </template>
        </el-menu>
      </el-col>
      <el-col :span="6" class="headlerrightbtn flexstart">
        <!--				<el-button type="warning" @click="showdialog('/login')">登录</el-button>-->
        <el-button type="warning"  @click="showdialog('/register')" >注册</el-button>
        <!--				<el-button type="danger" @click="$router.push('/login?type=4')" >业务协同平台</el-button>-->
      </el-col>
    </el-row>
    <el-dialog :title="topath == '/login' ? '请选择登录方式' : '请选择注册方式'" :visible.sync="dialogVisible" width="500px">
      <el-radio-group v-model="usertype" style="margin-bottom: 30px;margin-left: 115px;" @change="selectLogo">
        <el-radio-button label="1" v-if="topath != '/register'">业主登录</el-radio-button>
        <el-radio-button label="2">投标人{{ topath == "/login" ? "登录" : "注册" }}</el-radio-button>
        <el-radio-button label="3">代理机构{{ topath == "/login" ? "登录" : "注册" }}</el-radio-button>
        <el-radio-button label="4" v-if="topath != '/register'">评标专家登录</el-radio-button>
      </el-radio-group>
    </el-dialog>
    <!-- <el-dialog title="实名认证" :visible.sync="showbox" width="500px">
    </el-dialog> -->
  </div>
</template>

<script>
import Cookies from 'js-cookie'
export default {
  data() {
    return {
      showbox: true,
      dialogVisible: false,
      usertype: "0",
      topath: "",
      current: "/home",
      islogin: false,//是否已登陆
      menuItems: [
        {
          label: "首页",
          location: "/home",
        },
        {
          label: "交易信息",
          location: "/about",
        },
        {
          label: "保函系统",
          location: "/guarantee",
        },
        {
          label: "帮助中心",
          location: "/help",
        },
        {
          label: "下载中心",
          location: "/download",
        },
        {
          label: "关于我们",
          location: "/ourself",
        },
      ],
    };
  },
  created() {
    // if (Cookies.get('Admin-Token')) this.islogin = true;
    let menu = sessionStorage.getItem("menu");
    this.current = menu ? (menu == "/" ? "/home" : menu) : "/home";
  },
  mounted() {
    this.$bus.$on("changeMainNav", (data) => {
      this.current = data
    });
  },
  methods: {
    // 顶部导航跳转
    handleSelect(path) {
      this.toPage(path);
    },
    showdialog(path) {
      this.dialogVisible = true;
      this.topath = path;
    },
    // 页面跳转
    toPage(path, val) {
      if(path == '/guarantee') return  window.open('http://www.gzzczb.com/guarantee/')
      this.$router.push({ path: path, query: { type: val } });
      // window.open(`http://www.gzzczb.com/${val}`)
    },
    selectLogo(val) {
      if (this.usertype == 4 && this.topath == "/login") {
        window.location.href = "http://www.gzzczb.com/ui/#/login2"
      } else {
        window.open(`http://www.gzzczb.com/register?type=${val}`)
        // this.toPage(this.topath, val);
      }

    },
  },
  watch: {
    '$route': {
      immediate: true,
      handler(n) {
        if (n.path.indexOf('about') != -1) {
          this.$nextTick(() => this.current = '/about')
        } else {
          this.$nextTick(() => this.current = n.path)
        }
      }
    }
  }
};
</script>
<style scoped lang="less">
.headler {
  height: 61px;

  /deep/ .el-menu-item {
    padding: 0 3px;
    height: 46px;
    margin: 0 17px;
  }

  /deep/ .el-menu.el-menu--horizontal {
    border-bottom: none;
  }

  &>div {
    height: inherit;
    align-items: center;
  }

  .headlerrightbtn {
    button {
      height: 30px;
      line-height: 30px;
      padding: 0 20px;
    }
  }
}

.headlerlogotitle {
  height: 61px;
  font-size: 18px;
  color: #f18c1d;
  font-weight: bold;
  padding-right: 26px;

  span {
    margin: 0 10px;
  }
}

.registerClass {
  background-color: #F18C1D;
  border: none;
  width: 80px;
  height: 40px;
  color: #FFFFFF;
  font-size: 20px;
  border-radius: 4px;
  padding: 4px;
  line-height: 30px;
}

::v-deep .el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: 4px solid rgb(241, 140, 29);
}
</style>
